import { Input, Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { omit } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';

const VALUE_OTHER = 'other';

interface SelectWithOtherProps extends SelectProps {
  value?: any;
  /**
   * This callback is used by Form.Item to catch the returned value
   * @param value
   * @returns
   */
  onChange?: (value: any) => void;
  otherPlaceHolder?: string;
}

export function SelectWithOther(props: SelectWithOtherProps) {
  const options = useMemo(() => props.options ?? [], [props.options]);

  const rest = omit(props, ['value', 'onChange']);
  const [selectInternalValue, setSelectInternalValue] = useState(props.value);
  const [inputInternalValue, setInputInternalValue] = useState('');

  useEffect(() => {
    const isValueInOptionsEffect = options.some(
      option => option.value === props.value && option.value !== VALUE_OTHER
    );
    const isCurrentlyOtherSelectedEffect =
      props.value === VALUE_OTHER ||
      (!isValueInOptionsEffect && props.value && props.value !== VALUE_OTHER);

    setSelectInternalValue(
      isCurrentlyOtherSelectedEffect ? VALUE_OTHER : props.value
    );
    setInputInternalValue(
      isCurrentlyOtherSelectedEffect && props.value !== VALUE_OTHER
        ? props.value
        : ''
    );
  }, [props.value, options]);

  function handleSelectChange(selectedValue: string) {
    setSelectInternalValue(selectedValue);
    setInputInternalValue('');

    if (selectedValue !== VALUE_OTHER) {
      setInputInternalValue('');
      props.onChange?.(selectedValue);
    }
  }

  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    setInputInternalValue(e.target.value);
    props.onChange?.(e.target.value);
  }

  return (
    <div>
      <Select
        {...rest}
        options={options}
        value={selectInternalValue}
        onChange={handleSelectChange}
      />
      {selectInternalValue === VALUE_OTHER && (
        <Input
          data-private="lipsum"
          style={{ marginTop: '8px' }}
          value={inputInternalValue}
          onChange={handleInputChange}
          placeholder={props.otherPlaceHolder}
        />
      )}
    </div>
  );
}
